export const openPopup = (action) => ({
  type: 'INTEGRATIONS_DISCONNECT_POPUP_OPEN',
  payload: { action }
})

export const closePopup = () => ({
  type: 'INTEGRATIONS_DISCONNECT_POPUP_CLOSE'
})

export const startSubmitting = () => ({
  type: 'INTEGRATIONS_DISCONNECT_POPUP_START_SUBMITTING'
})

export const stopSubmitting = () => ({
  type: 'INTEGRATIONS_DISCONNECT_POPUP_STOP_SUBMITTING'
})
